import {toast} from "react-toastify";

export const toast_configs = (toast_text, toast_type, options = {}) => {
    if (toast_type === "success") {
        return toast.success(toast_text, options);
    } else if (toast_type === "error") {
        return toast.error(toast_text, options);
    } else if (toast_type === "warning") {
        return toast.warn(toast_text, options);
    } else if (toast_type === "info") {
        return toast.info(toast_text, options);
    }
};